import React from 'react';
import PropTypes from 'prop-types';

import { USD } from 'helpers/formatters/number_formats';

export function TiersTable({ royaltySchedule }) {
  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>Tier</th>
            <th className="text-end">From</th>
            <th className="text-end">To</th>
            <th className="text-end">Royalty %</th>
          </tr>
        </thead>

        <tbody>
          {royaltySchedule.tiers.map((tier, index) => (
            <tr key={index}>
              <td>Tier {index + 1}</td>
              <td className="text-end">{USD.format(tier.from, { round: true })}</td>
              <td className="text-end">
                {tier.to ? USD.format(tier.to, { round: true }) : 'Unlimited'}
              </td>
              <td className="text-end">
                {tier.royaltyPercentage}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

TiersTable.propTypes = {
  royaltySchedule: PropTypes.shape({
    tiers: PropTypes.array.isRequired,
  }).isRequired,
};

export default TiersTable;
